import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "bridgetown-quick-search/dist"
import * as Turbo from "@hotwired/turbo"

// Example Shoelace components. Mix 'n' match however you like!
import "@shoelace-style/shoelace/dist/components/button/button.js"
import "@shoelace-style/shoelace/dist/components/icon/icon.js"
import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js"
import "@shoelace-style/shoelace/dist/components/spinner/spinner.js"
import "@shoelace-style/shoelace/dist/components/badge/badge.js"
import "@shoelace-style/shoelace/dist/components/tooltip/tooltip.js"

// Use the public icons folder:
import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js"
setBasePath("/shoelace-assets")

import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library.js';

registerIconLibrary('fa', {
    resolver: (name) => {
        const parts = name.split('-');
        let style = 'regular'; // Default style
        console.info(`parts: ${parts}`);
        if (parts.length > 1) {
            const stylePrefix = parts[0];
            console.info(`stylePrefix: ${stylePrefix}`);
            name = parts.slice(1).join('-');
            if (stylePrefix === 'fas') style = 'solid';
            else if (stylePrefix === 'fal') style = 'light';
            else if (stylePrefix === 'fat') style = 'thin';
            else if (stylePrefix === 'fad') style = 'duotone';
            else if (stylePrefix === 'fab') style = 'brands';
        }
        console.info(`name: ${name}`);
        console.info(`style: ${style}`);
    // This URL path should point to your hosted Font Awesome SVG files
    // E.g., if you self-host in an 'assets/icons/fa' folder
        return `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@7.2.0/svgs/${style}/${name}.svg`;
    },
  // Optional: set the default library to 'fa'
  // This will make <sl-icon name="icon-name"></sl-icon> use Font Awesome by default
  // This part requires checking if this is possible via the public API, the current search results suggest it is possible to override the system/default library
});

// Uncomment the line below to add transition animations when Turbo navigates.
// We recommend adding <meta name="turbo-cache-control" content="no-preview" />
// to your HTML head if you turn on transitions. Use data-turbo-transition="false"
// on your <main> element for pages where you don't want any transition animation.
//
// import "./turbo_transitions.js"

// Import all JavaScript & CSS files from src/_components
import components from "bridgetownComponents/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
